
import { sourceInfo } from '@/api/assist'
import { defineComponent, onMounted, PropType, ref } from 'vue'
import { getLang } from '@/hooks/lang'

export default defineComponent({
  props: {
    sourceInfo: {
      type: Object as PropType<sourceInfo>,
      required: false,
      default: () => ({}),
    },
  },
  setup(props) {
    const dialogRef = ref<HTMLDivElement>()
    const isExpDialog = ref(false)
    const isAbsDialog = ref(false)
    const lang = getLang()

    const expandDialog = () => {
      isExpDialog.value = !isExpDialog.value
    }
    const expandAbstract = () => {
      isAbsDialog.value = !isAbsDialog.value
    }

    const goRp = (rdPaperId: string) => {
      window.open(`https://readpaper.com/paper/${rdPaperId}`, '_blank')
    }

    onMounted(() => {
      if (props.sourceInfo.topicParagraph.split(' ').length < 150) {
        isExpDialog.value = false
        ;(dialogRef.value as any).style.height = 'auto'
      }
    })
    return {
      dialogRef,
      expandDialog,
      isExpDialog,
      isAbsDialog,
      expandAbstract,
      goRp,
      lang,
    }
  },
  methods: {},
})
